export const PARAMS_ID = {
  dependents: 'dep',
  movements: 'mov',
} as const;
